import request from '@/utils/request';
// 获取评价列表
export function queryOrderRatePageApi(data) {
  return request({
    url: '/ecom/ai/queryOrderRatePage',
    method: 'post',
    data
  })
}
// 回评文案修改
export function updateOrderRateApi(data) {
  return request({
    url: '/ecom/ai/updateOrderRate',
    method: 'post',
    data
  })
}
// 回评文案推送平台
export function resendRateContentApi(data) {
  return request({
    url: '/ecom/ai/resendRateContent',
    method: 'post',
    data
  })
}